import * as React from 'react';
export default class Column extends React.Component {
}



// WEBPACK FOOTER //
// ./components/table/Column.tsx